import React from 'react';

const COLUMN_WIDTHS = [40, 220, 220, 160, 280];
const ROW_HEIGHT = 38;
const ROW_COUNT = 20;
const BAR_FRACTION = 0.65;

export const ReportTableSkeleton: React.FC = () => {
  return (
    <div className="flex flex-1 flex-col overflow-hidden">
      <div className="flex flex-1 flex-col" style={{ minWidth: 'max-content' }}>
        {/* Header skeleton */}
        <div className="sticky top-0 z-10 flex items-center border-b border-gray-200 bg-gray-50 px-4 py-2">
          {COLUMN_WIDTHS.map((w, i) => (
            <div
              key={i}
              className="mx-1.5 py-1"
              style={{ width: `${w}px`, minWidth: `${w}px` }}
            >
              <div
                className="h-3.5 animate-pulse rounded bg-gray-200"
                style={{ width: `${Math.round(w * BAR_FRACTION)}px` }}
              />
            </div>
          ))}
        </div>

        {/* Body skeleton rows */}
        <div className="flex-1">
          {Array.from({ length: ROW_COUNT }).map((_, rowIdx) => (
            <div
              key={rowIdx}
              className="flex items-center border-b border-gray-200 px-4 py-2"
              style={{ height: `${ROW_HEIGHT}px` }}
            >
              {COLUMN_WIDTHS.map((w, colIdx) => (
                <div
                  key={colIdx}
                  className="mx-1.5"
                  style={{ width: `${w}px`, minWidth: `${w}px` }}
                >
                  <div
                    className="h-3.5 animate-pulse rounded bg-gray-200"
                    style={{ width: `${Math.round(w * BAR_FRACTION)}px` }}
                  />
                </div>
              ))}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
